import { render, staticRenderFns } from "./SaleCreate.vue?vue&type=template&id=913e20ee&scoped=true&"
import script from "./SaleCreate.vue?vue&type=script&lang=js&"
export * from "./SaleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913e20ee",
  null
  
)

export default component.exports